import { Component, OnInit, ViewChild } from '@angular/core';
import { EstadoService } from '../../_services/estado.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Estado } from '../../_models/estado';
import { ActivatedRoute, Params } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { ListaService } from '../../_services/lista.service';
import { forkJoin, of } from 'rxjs';
import { ListaItem } from '../../_models/lista-item';
import { EstadoAdjuntoService } from '../../_services/estado-adjunto.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppSettings } from '../../../proyect.conf';
import { FileUpload } from 'primeng/fileupload';
import { EstadoAdjunto } from '../../_models/estado-adjunto';
import { ConstanteService } from '../../_services/constante.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { SegmentoAdjunto } from '../../_models/segmento-adjunto';
import { EstadoTipoProductoService } from '../../_services/estado-tipo-producto.service';
import { EstadoTipoProducto } from '../../_models/estado-tipo-producto';

function alMenosUnTipoProducto( control: AbstractControl ) {
  return control.value && control.value.length > 0 ? null : { required: true };
}

@Component( {
  selector: 'app-estados-editar',
  templateUrl: 'estados-editar.component.html'
} )

export class EstadosEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  estado: Estado;
  lisEstados: Estado[] = [];
  formulario: FormGroup;
  lisEstadosPasar: SelectItem[] = [];
  lisCausales: SelectItem[] = [];
  lisTiposProducto: SelectItem[] = [];
  asociacionesEstado: EstadoTipoProducto[] = [];
  submitted = false;
  carImagen = false;
  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  nomArchivo: string;
  maxSize: number;
  @ViewChild('adjunto') adjunto: FileUpload;
  estAdjunto: EstadoAdjunto;

  constructor( private estServicio: EstadoService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private estAdjuntoServicio: EstadoAdjuntoService,
               private conConstanteService: ConstanteService,
               private adjService: AdjuntoService,
               private autServicio: AutenticacionService,
               private sanitizer: DomSanitizer,
               private navServicio: NavService,
               private estadoTipoProductoServicio: EstadoTipoProductoService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.estServicio.obtenerPorId( params[ 'id' ] ),
          this.estAdjuntoServicio.obtenerPorEstado( params[ 'id' ] ) ).subscribe( ( [ estado, estAdjunto ] ) => {
          this.estado = estado;
          this.estAdjunto = estAdjunto;
          if ( this.estAdjunto && this.estAdjunto.indicadorHabilitado ) {
            this.cargarAdjunto( this.estAdjunto.idAdjunto, this.estAdjunto.nombreAdjunto );
          }
          this.carServiciosIniciales();
        } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  cargarAdjunto( idAdjunto: string, nombre: string ) {
    this.carImagen = true;
    this.adjService.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      this.nomArchivo = nombre;
      this.cargarReaderImagen( adjunto );
      this.carImagen = false;
    }, error => {
      this.carImagen = false;
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idEstado: [ this.estado ? this.estado.idEstado : null ],
      codigo: [ this.estado ? this.estado.codigo : null, [ Validators.required, Validators.maxLength( 20 ) ] ],
      nombre: [ this.estado ? this.estado.nombre : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      diasCancela: [ this.estado ? this.estado.diasCancela : null, ( this.estado && this.estado.indicadorCambioEstado ) ? [ Validators.required, Validators.maxLength( 4 ) ] : [] ],
      idEstadoAnterior: [ this.estado ? this.estado.idEstadoAnterior : null, ( this.estado && this.estado.indicadorCambioEstado ) ? [ Validators.required ] : [] ],
      idCausal: [ this.estado ? this.estado.idCausal : null, ( this.estado && this.estado.indicadorCambioEstado ) ? [ Validators.required ] : [] ],
      indicadorEstadoInicial: [ this.estado ? this.estado.indicadorEstadoInicial : false ],
      indicadorEstadoFinal: [ this.estado ? this.estado.indicadorEstadoFinal : false ],
      indicadorCambioEstado: [ this.estado ? this.estado.indicadorCambioEstado : false ],
      indicadorCambioEstadoDigital: [ this.estado ? this.estado.indicadorCambioEstadoDigital : false ],
      indicadorAprobado: [ this.estado ? this.estado.indicadorAprobado : false ],
      indicadorUnidadCredito: [ this.estado ? this.estado.indicadorUnidadCredito : false ],
      indicadorDesembolso: [ this.estado ? this.estado.indicadorDesembolso : false ],
      indicadorCheckDocumental: [ this.estado ? this.estado.indicadorCheckDocumental : false ],
      indicadorComite: [ this.estado ? this.estado.indicadorComite : false ],
      indicadorVisita: [ this.estado ? this.estado.indicadorVisita : false ],
      indicadorPerfilado: [ this.estado ? this.estado.indicadorPerfilado : false ],
      indicadorHabilitado: [ this.estado ? this.estado.indicadorHabilitado : true ],
      indicadorAliado: [ this.estado ? this.estado.indicadorAliado : false ],
      indicadorCancela: [ this.estado ? this.estado.indicadorCancela : false ],
      auditoriaUsuario: [ this.estado ? this.estado.auditoriaUsuario : null ],
      auditoriaFecha: [ this.estado ? this.estado.auditoriaFecha : null ],
      indicadorBloqueado: [ this.estado ? this.estado.indicadorBloqueado : false ],
      idAdjunto: [ ( this.estAdjunto && this.estAdjunto.indicadorHabilitado ) ? this.estAdjunto.idAdjunto : null ],
      diasCancelaDigital: [ this.estado ? this.estado.diasCancelaDigital : null, ( this.estado && this.estado.indicadorCambioEstadoDigital ) ? [ Validators.required, Validators.maxLength( 4 ) ] : [] ],
      idEstadoAnteriorDigital: [ this.estado ? this.estado.idEstadoAnteriorDigital : null, ( this.estado && this.estado.indicadorCambioEstadoDigital ) ? [ Validators.required ] : [] ],
      idCausalDigital: [ this.estado ? this.estado.idCausalDigital : null, ( this.estado && this.estado.indicadorCambioEstadoDigital ) ? [ Validators.required ] : [] ],
      indicadorFabricaCredito: [ this.estado ? this.estado.indicadorFabricaCredito : false ],
      indicadorBloqueadoSarlaft: [ this.estado ? this.estado.indicadorBloqueadoSarlaft : false ],
      indicadorCalificarReferencias: [ this.estado ? this.estado.indicadorCalificarReferencias : false ],
      indicadorMostrarCliente: [ this.estado ? !!this.estado.indicadorMostrarCliente : false ],
      idsTiposProducto: [ [], alMenosUnTipoProducto ]
    } );

    const asociaciones$ = this.estado && this.estado.idEstado ? this.estadoTipoProductoServicio.listado() : of( [] );
    forkJoin( this.estServicio.listado(), this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ),
      this.conConstanteService.getByCode( 'FSIZE' ),
      this.lisServicio.getMasterDetails( 'ListasTiposProductosBancarios' ),
      asociaciones$ ).subscribe( ( [ estados, lisCausales, tamMaximo, tiposProducto, asociaciones ] ) => {
      this.lisEstados = estados;
      this.lisTiposProducto = ( tiposProducto || [] ).map( ( item: ListaItem ) => ( { label: item.nombre, value: item.idLista } ) );
      this.asociacionesEstado = ( asociaciones || [] ).filter( item => this.estado && item.idEstado === this.estado.idEstado );
      this.f.idsTiposProducto.setValue( this.asociacionesEstado.filter( item => item.indicadorHabilitado ).map( item => item.idTipoProducto ) );
      this.maxSize = ( tamMaximo && tamMaximo.valor ) ? Number( tamMaximo.valor ) : 50000000;
      lisCausales.map( ( s: ListaItem ) => {
        this.lisCausales.push( { label: s.nombre, value: s.idLista } );
      } );
      estados.map( ( s: Estado ) => {
        if ( s.indicadorHabilitado && ( !this.estado || this.estado.idEstado !== s.idEstado ) ) {
          this.lisEstadosPasar.push( { label: s.nombre, value: s.idEstado } );
        }
      } );
      this.carInformacionInicial = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      let mensaje = '';
      const estActualizarInicial = [];
      const estActualizarBloqueado = [];
      const estActualizarFabrica = [];
      const estInicial = this.lisEstados.find( x => x.indicadorEstadoInicial && this.f.idEstado.value !== x.idEstado );
      if ( estInicial && this.f.indicadorEstadoInicial.value ) {
        mensaje = this.navServicio.buscarMensaje( 'ESTADOS.MSG_EXISTEINICIAL' );
        estActualizarInicial.push( estInicial );
      }
      const estBloqueadoSarlaft = this.lisEstados.find( x => x.indicadorBloqueadoSarlaft && this.f.idEstado.value !== x.idEstado );
      if ( estBloqueadoSarlaft && this.f.indicadorBloqueadoSarlaft.value ) {
        mensaje = this.navServicio.buscarMensaje( 'ESTADOS.MSG_SARLAFT' );
        estActualizarBloqueado.push( estBloqueadoSarlaft );
      }
      const estFabricaCredito = this.lisEstados.find( x => x.indicadorFabricaCredito && this.f.idEstado.value !== x.idEstado );
      if ( estFabricaCredito && this.f.indicadorFabricaCredito.value ) {
        mensaje = this.navServicio.buscarMensaje( 'ESTADOS.MSG_FABRICA' );
        estActualizarFabrica.push( estFabricaCredito );
      }
      if ( estActualizarInicial.length > 0 || estActualizarBloqueado.length > 0 || estActualizarFabrica.length > 0) {
        this.conServicio.confirm( {
          message: mensaje,
          header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          key: 'confirmar-check',
          accept: () => {
            if(estActualizarInicial.length > 0) {
              estActualizarInicial.map( ( s: Estado ) => {
                if ( estInicial && s.idEstado == estInicial.idEstado ) {
                  s.indicadorEstadoInicial = false;
                }
              } );
              this.guardarEstado( estActualizarInicial );
            }
            if(estActualizarBloqueado.length > 0){
              estActualizarBloqueado.map( ( s: Estado ) => {
                if ( estBloqueadoSarlaft && s.idEstado == estBloqueadoSarlaft.idEstado ) {
                  s.indicadorBloqueadoSarlaft = false;
                }
              } );
              this.guardarEstado( estActualizarBloqueado );
            }
            if(estActualizarFabrica.length > 0){
              estActualizarFabrica.map( ( s: Estado ) => {
                if ( estFabricaCredito && s.idEstado == estFabricaCredito.idEstado ) {
                  s.indicadorFabricaCredito = false;
                }
              } );
              this.guardarEstado( estActualizarFabrica );
            }

          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.guardarEstado( [] );
      }
    }
  }

  async validarAdjuntos( estado: any ) {
    if ( estado.idAdjunto && ( !this.estAdjunto || this.estAdjunto.idAdjunto !== estado.idAdjunto ) ) {
      const registro = this.estAdjunto ? this.estAdjunto : {} as EstadoAdjunto;
      registro.indicadorHabilitado = true;
      registro.idEstado = estado.idEstado;
      registro.idAdjunto = estado.idAdjunto;
      this.estAdjunto = await ( registro.idEstadoAdjunto ? this.estAdjuntoServicio.actualizar( registro ) : this.estAdjuntoServicio.crear( registro ) ).toPromise();
      this.estAdjunto.nombreAdjunto = this.nomArchivo;
    } else if ( !estado.idAdjunto && this.estAdjunto && this.estAdjunto.indicadorHabilitado ) {
      this.estAdjunto.indicadorHabilitado = false;
      await this.estAdjuntoServicio.actualizar( this.estAdjunto ).toPromise();
    }
    return true;
  }

  guardarEstado( estActualizar: Estado[] ) {
    const valor = { ...this.formulario.value };
    const idsTiposProducto: string[] = valor.idsTiposProducto || [];
    delete valor.idsTiposProducto;
    if ( !valor.idEstado ) {
      delete valor.orden;
    }
    this.estado = valor;
    estActualizar.push( this.estado );
    this.estServicio.bulk( estActualizar ).subscribe( async rta => {
      const objUltimo = rta[ rta.length - 1 ];
      this.estado.idEstado = objUltimo.idEstado;
      await this.validarAdjuntos(this.estado);
      this.sincronizarTiposProducto( this.estado.idEstado, idsTiposProducto );
    }, error => {
      this.navServicio.setMesage( 3 );
      this.guardando = false;
    } );
  }

  sincronizarTiposProducto( idEstado: string, idsSeleccionados: string[] ) {
    const seleccion = new Set( idsSeleccionados || [] );
    const llamadas = [];
    this.asociacionesEstado.forEach( asociacion => {
      const sigueSeleccionada = seleccion.has( asociacion.idTipoProducto );
      if ( sigueSeleccionada && !asociacion.indicadorHabilitado ) {
        llamadas.push( this.estadoTipoProductoServicio.actualizar( { ...asociacion, indicadorHabilitado: true } ) );
      }
      if ( !sigueSeleccionada && asociacion.indicadorHabilitado ) {
        llamadas.push( this.estadoTipoProductoServicio.actualizar( { ...asociacion, indicadorHabilitado: false } ) );
      }
      seleccion.delete( asociacion.idTipoProducto );
    } );
    seleccion.forEach( idTipoProducto => {
      llamadas.push( this.estadoTipoProductoServicio.crear( {
        idEstado,
        idTipoProducto,
        indicadorHabilitado: true
      } ) );
    } );
    if ( llamadas.length === 0 ) {
      this.finalizarGuardado();
      return;
    }
    forkJoin( llamadas ).subscribe( () => {
      this.finalizarGuardado();
    }, () => {
      this.navServicio.setMesage( 3 );
      this.guardando = false;
    } );
  }

  private finalizarGuardado() {
    this.navServicio.setMesage( 2 );
    this.guardando = false;
    this.location.back();
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'confirmar-check',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisEstados.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  checkUnicoBloqueoFabrica(checked: boolean, bloqueado: boolean) {
    if ( checked && bloqueado ) {
      this.f.indicadorBloqueadoSarlaft.setValue( false );
    } else if ( checked ) {
      this.f.indicadorFabricaCredito.setValue( false );
    }
  }

  cambioCambioEstado( checked: boolean ) {
    this.f.idEstadoAnterior.clearValidators();
    this.f.idCausal.clearValidators();
    this.f.diasCancela.clearValidators();
    if ( checked ) {
      this.f.idEstadoAnterior.setValidators( [ Validators.required ] );
      this.f.idCausal.setValidators( [ Validators.required ] );
      this.f.diasCancela.setValidators( [ Validators.required, Validators.maxLength( 4 ) ] );
    } else {
      this.f.idEstadoAnterior.setValue( null );
      this.f.diasCancela.setValue( null );
      this.f.idCausal.setValue( null );
      this.f.idEstadoAnterior.setValidators( [] );
      this.f.diasCancela.setValidators( [] );
      this.f.idCausal.setValidators( [] );
    }
  }

  cambioCambioEstadoDigital( checked: boolean ) {
    this.f.idEstadoAnteriorDigital.clearValidators();
    this.f.idCausalDigital.clearValidators();
    this.f.diasCancelaDigital.clearValidators();
    if ( checked ) {
      this.f.idEstadoAnteriorDigital.setValidators( [ Validators.required ] );
      this.f.idCausalDigital.setValidators( [ Validators.required ] );
      this.f.diasCancelaDigital.setValidators( [ Validators.required, Validators.maxLength( 4 ) ] );
    } else {
      this.f.idEstadoAnteriorDigital.setValue( null );
      this.f.diasCancelaDigital.setValue( null );
      this.f.idCausalDigital.setValue( null );
      this.f.idEstadoAnteriorDigital.setValidators( [] );
      this.f.diasCancelaDigital.setValidators( [] );
      this.f.idCausalDigital.setValidators( [] );
    }
  }

  cambioIndicadorEstados( checked: boolean, inicial: boolean ) {
    if ( checked && inicial ) {
      this.f.indicadorEstadoFinal.setValue( false );
    } else if ( checked ) {
      this.f.indicadorEstadoInicial.setValue( false );
    }
  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  cancelarAdjunto() {
    this.f.idAdjunto.setValue( null );
    this.f.idAdjunto.markAsDirty();
    this.imagen = null;
  }

  onBeforeSend( event: any ) {
    this.carImagen = true;
    this.adjService.cargarArchivo( event, this.nomArchivo, '/Estados' );
  }

  onUpload( event: any ) {
    console.log( JSON.stringify(event) );
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto ) {
      this.f.idAdjunto.setValue( respuesta.idAdjunto );
      this.f.idAdjunto.markAsDirty();
      this.carImagen = false;
    }
  }

  onSelect( event: any, file: any ) {
    console.log( JSON.stringify(event) );
    console.log( JSON.stringify(file) );
    console.log( JSON.stringify(file[0]) );
    if ( this.adjunto.msgs.length === 0 ) {
      this.nomArchivo = file[ 0 ].name;
      this.cargarReaderImagen( file[ 0 ] );
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }

  }

}
